import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import * as Service from '../services/ApplyCode';
import type {
  IApplyCodeErrorBody,
  IApplyCodeParams,
  TApplyCodeResponse,
} from '../types/DiscountCode.types';
import { discountCodeKeys } from './useGetDiscountCodes';

/**
 * Applies a code to the current office and refreshes the history list so the new
 * card appears without a manual refetch.
 *
 * Errors are typed as `AxiosError<IApplyCodeErrorBody>` and deliberately NOT
 * swallowed here: the dialog needs the `reason` to tell its four distinct
 * failure states apart, and it owns the error display.
 */
export const useApplyCode = () => {
  const queryClient = useQueryClient();

  return useMutation<TApplyCodeResponse, AxiosError<IApplyCodeErrorBody>, IApplyCodeParams>({
    mutationFn: (params) => Service.applyCode(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: discountCodeKeys.all });
    },
    meta: { skipGlobalErrorToaster: true },
  });
};
